import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const providerApi = createApi({
  reducerPath: 'providerApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Provider'],
  endpoints: (builder) => ({
    getProviders: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/provider',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Provider'],
    }),
    addProvider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-provider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Provider'],
    }),
    deleteProvider: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-provider',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Provider'],
    }),
  }),
});

export const {
  useGetProvidersQuery,
  useAddProviderMutation,
  useDeleteProviderMutation,
} = providerApi;
